<template>
  <div class="comp-address-picker">
    
    <input
    v-model="searchInput"
    v-on:keyup.enter="onEnterKey"
    ref="searchInput"
    class="text-input" type="text" placeholder="Enter address" />

    <div
    ref="googleMap"
    class="map-container"></div>


    <div
    ref="infowindowContent"
    class="infowindow-content">
      <span id="place-name" style="font-weight: bold;"></span><br>
      <span id="place-address"></span>
    </div>

    <div
    v-on:click="close"
    v-bind:class="{
      active: place
    }"
    class="close-btn">{{place ? 'Confirm' : 'Cancel'}}</div>

  </div>
</template>

<script>
import googleAPI from '@/apis/google'
import CompIcon from '@/components/CompIcon'
export default {
  name: 'comp-address-picker',
  components: {
    CompIcon
  },
  props: {
    address: null, // string
    lat: null, // number
    lng: null // number
  },
  computed: {
  },
  data: function () {
    return {
      zoom: 18, // Why 18? Because it looks good.
      map: null,
      marker: null,
      infowindow: null,
      searchInput: null,
      place: null,
      placeLat: null,
      placeLng: null,
      placePostalCode: null,
      autocomplete: null,
      placeChanged$e: null,
      dragEnd$e: null
    }
  },
  watch: {
  },
  mounted: function () {
    // this.checkIfValidAddress()
    setTimeout(() => { this.init() }, 500)
  },
  beforeDestroy: function () {
    if (this.placeChanged$e) {
      this.$googlemap.google.maps.event.removeListener(this.placeChanged$e)
      this.getAutocompletePacContainer(this.autocomplete).remove()
    }
    if (this.dragEnd$e) {
      this.$googlemap.google.maps.event.removeListener(this.dragEnd$e)
    }
  },
  methods: {
    close: function () {
      this.$emit('onClose', {
        'address': this.searchInput,
        'lat': this.placeLat,
        'lng': this.placeLng,
        'zip': this.placePostalCode
      })
    },
    checkIfValidAddress: function () {
      if (this.address && this.lat && this.lng && !this.searchInput) {
        this.searchInput = this.address
        this.placeLat = this.lat
        this.placeLng = this.lng
        this.refreshMapCenter()
      }
    },
    init: function () {
      this.loadGoogleMapLib()
    },
    loadGoogleMapLib: function () {
      if (!this.$googlemap.isLoaded) {
        this.$googlemap.loadScript((isSuccess) => {
          if (isSuccess) {
            this.initAutoComplete()
            this.initMap()
            this.checkIfValidAddress()
          }
        })
      } else {
        this.initAutoComplete()
        this.initMap()
        this.checkIfValidAddress()
      }
    },
    initMap: function () {
      if (this.$refs['googleMap'] && this.$refs['infowindowContent']) {
        this.map = new this.$googlemap.google.maps.Map(this.$refs['googleMap'], {
          center: {lat: 40.7127753, lng: -74.0059728},
          zoom: this.zoom,
          scaleControl: false,
          streetViewControl: false,
          mapTypeControl: false
        })
        this.marker = new this.$googlemap.google.maps.Marker({
          map: this.map,
          draggable: true,
          animation: this.$googlemap.google.maps.Animation.DROP,
          anchorPoint: new this.$googlemap.google.maps.Point(0, -29)
        })
        this.dragEnd$e = this.marker.addListener('dragend', (event) => {
          this.onMarkerMoved(event)
        })
        this.infowindow = new this.$googlemap.google.maps.InfoWindow()
        this.infowindow.setContent(this.$refs['infowindowContent'])
      }
    },
    initAutoComplete: function () {
      if (this.$refs['searchInput']) {
        this.autocomplete = new this.$googlemap.google.maps.places.Autocomplete(this.$refs['searchInput'], {
          types: [
            // return only geocoding results, rather than business results.
            'geocode'
          ]
        })
        this.placeChanged$e = this.autocomplete.addListener('place_changed', () => {
          this.onPlaceChanged()
        })
      }
    },
    getAutocompletePacContainer: function (autocomplete) {
      let place = autocomplete.gm_accessors_.place
      let placeKey = Object.keys(place).find((value) => (
        (typeof place[value] === 'object') && (place[value].hasOwnProperty('gm_accessors_'))
      ))
      let input = place[placeKey].gm_accessors_.input[placeKey]
      let inputKey = Object.keys(input).find((value) => (
        (input[value].classList && input[value].classList.contains('pac-container'))
      ))
      return input[inputKey]
    },
    onMarkerMoved: function (event) {
      let lat = event.latLng.lat()
      let lng = event.latLng.lng()
      googleAPI.getAddressOfGeoCode({lat, lng}).then(
        res => {
          let place = res.body.results[0]
          this.placeLat = place.geometry.location.lat
          this.placeLng = place.geometry.location.lng
          this.placePostalCode = this.getPostalCode(place.address_components)
          this.searchInput = place.formatted_address
          this.$refs['infowindowContent'].children['place-name'].textContent = 'New address'
          this.$refs['infowindowContent'].children['place-address'].textContent = this.searchInput
          // make it valid address
          this.place = place
        },
        err => {
          console.log(err)
        }
      )
    },
    onPlaceChanged: function () {
      this.place = this.autocomplete.getPlace()
      this.marker.setVisible(false)
      if (!this.place.geometry) {
        return
      }
      this.placeLat = this.place.geometry.location.lat()
      this.placeLng = this.place.geometry.location.lng()
      this.placePostalCode = this.getPostalCode(this.place.address_components)

      this.searchInput = this.place.formatted_address
      // if (this.place.geometry.viewport) {
      //   this.map.fitBounds(this.place.geometry.viewport)
      // } else {
      //   this.map.setCenter(this.place.geometry.location)
      //   this.map.setZoom(this.zoom)
      // }
      this.map.setCenter(this.place.geometry.location)
      this.map.setZoom(this.zoom)
      this.marker.setPosition(this.place.geometry.location)
      this.marker.setVisible(true)

      this.$refs['infowindowContent'].children['place-name'].textContent = 'New address'
      this.$refs['infowindowContent'].children['place-address'].textContent = this.searchInput
      this.infowindow.open(this.map, this.marker)
    },
    refreshMapCenter: function () {
      this.marker.setVisible(false)
      let latLng = {lat: parseFloat(this.placeLat), lng: parseFloat(this.placeLng)}
      this.map.setCenter(latLng)
      this.map.setZoom(this.zoom)
      this.marker.setPosition(latLng)
      this.marker.setVisible(true)
      this.$refs['infowindowContent'].children['place-name'].textContent = 'Current address'
      this.$refs['infowindowContent'].children['place-address'].textContent = this.searchInput
      this.infowindow.open(this.map, this.marker)
    },
    onEnterKey: function () {
      if (this.place) {
        this.onPlaceChanged()
      }
    },
    getPostalCode: function (googleAddressComponents) {
      let postalCode = null
      try {
        googleAddressComponents.map(addrComp => {
          addrComp.types.map(addrCompType => {
            if (addrCompType === 'postal_code') {
              postalCode = addrComp.long_name
            }
          })
        })
      } catch (err) {}
      return postalCode
    }
  }
}
</script>

<style scoped>
  .comp-address-picker {
    /* common */
    background-color: hsla(0, 0%, 100%, 1);
    font-size: 16px;
    /* size */
    padding: 0;
    width: 100%;
    height: 100%;
    /* position */
    position: absolute;
    z-index: 1000;
    top: 0;
    left: 0;
    /* alignment */
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    justify-content: center;
  }

  .comp-address-picker .text-input {
    /* Remove First */
    -webkit-appearance: none;
    -moz-appearance: none;
    
    /* Then style */
    /* common */
    color: #333;
    font-size: 1em;
    background-color: transparent;
    /* size */
    width: calc(100% - 2px - 2em);
    border: 1px solid rgba(0,0,0,0.13);
    border-radius: 4px 4px 0 0;
    padding: 1em;
    /* style */
    outline: none;
    display: block;
  }
  .comp-address-picker .text-input:focus {
    /* style */
    border: 1px solid rgba(7,171,254,1);
  }

  .comp-address-picker .map-container {
    /* size */
    width: 100%;
    height: calc(100% - 6.5em);
    /* position */
  }

  .comp-address-picker .infowindow-content {
    display: none;
  }
  .comp-address-picker .map-container .infowindow-content {
    display: inline;
  }

  .comp-address-picker .close-btn {
    /* common */
    background-color: hsla(202, 0%, 50%, 1);
    color: #fff;
    /* text */
    font-weight: bold;
    /* size */
    padding: 1em;
    width: calc(100% - 2em);
    /* alignment */
    text-align: center;
    /* mouse */
    cursor: pointer;
  }
  .comp-address-picker .close-btn.active {
    /* common */
    background-color: hsla(202, 100%, 50%, 1);
  }
  .comp-address-picker .close-btn.active:hover {
    /* common */
    background-color: hsla(202, 100%, 40%, 1);
  }


</style>



// WEBPACK FOOTER //
// src/components/CompAddressPicker.vue